var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from 'react';
import { useDevice } from './useDevice';
import { createGlobalState } from '../store/createGlobalState';
import { useDisableScroll } from '../../ui';
var sidebar = createGlobalState({
    id: 'XR.useLayout.sidebar',
    initialValue: {
        sidebar: {},
        sidebarIdOpen: {},
    },
    autoSync: true
});
export function useLayout() {
    var _a = sidebar.useState(), sidebarState = _a[0], setSidebarState = _a[1];
    var device = useDevice();
    return {
        sidebar: {
            useRegister: function (_a) {
                var id = _a.id, visible = _a.visible, width = _a.width;
                useDisableScroll(device.isTouch && this.isOpen(id));
                useEffect(function () {
                    setSidebarState(function (state) {
                        var _a;
                        return (__assign(__assign({}, state), { sidebar: __assign(__assign({}, state.sidebar), (_a = {}, _a[id] = { id: id, visible: visible, width: width }, _a)) }));
                    });
                    return function () {
                        setSidebarState(function (state) {
                            var _a;
                            return (__assign(__assign({}, state), { sidebar: __assign(__assign({}, state.sidebar), (_a = {}, _a[id] = undefined, _a)) }));
                        });
                    };
                }, [id]);
            },
            getWidth: function (id) {
                var _a;
                return ((_a = this.getById(id)) === null || _a === void 0 ? void 0 : _a.width) || 0;
            },
            getPaddingLeft: function (id) {
                var _a;
                if (device.isTouch) {
                    return 0;
                }
                return this.isOpen(id) ? (_a = this.getById(id)) === null || _a === void 0 ? void 0 : _a.width : 0;
            },
            getById: function (id) {
                return sidebarState.sidebar[id];
            },
            toggleOpen: function (id, value) {
                setSidebarState(function (state) {
                    var _a;
                    return (__assign(__assign({}, state), { sidebarIdOpen: __assign(__assign({}, state.sidebarIdOpen), (_a = {}, _a[id] = value !== null && value !== void 0 ? value : !state.sidebarIdOpen[id], _a)) }));
                });
            },
            isOpen: function (id) {
                var _a;
                var visibleAuto = ((_a = this.getById(id)) === null || _a === void 0 ? void 0 : _a.visible) === 'auto';
                if (visibleAuto) {
                    if (device.isTouch) {
                        return sidebarState.sidebarIdOpen[id];
                    }
                    else {
                        return true;
                    }
                }
                return Boolean(sidebarState.sidebarIdOpen[id]);
            },
        },
    };
}
